// Göstermelik ödeme yöntemi ("göstermelik firma").
//
// Yönetici bir yöntemi vitrine koyup arkasına hesap tanımlamayabilir: yöntem
// listede adı, logosu ve limitleriyle görünür, üye tutarını girer, ama ödeme
// adımına geçtiğinde (çekimde: talep oluştururken) aşağıdaki uyarıyı alır.
//
// Uyarının metni panelden yazılabilir (`showcase_message`); boş bırakılırsa
// varsayılan cümle çizilir. Metin ve karar tek yerdedir çünkü üç ekran birden
// okur (yatırım yöntem penceresi, ödeme sayfası, çekim formu); ayrışsalardı
// aynı yöntem bir ekranda yöneticinin yazdığını, diğerinde varsayılanı
// söylerdi. Asıl kapı sunucudadır (`services/payment_showcase.py`) — oradaki
// varsayılan metin de bununla aynıdır.

export const SHOWCASE_UNAVAILABLE_TITLE = 'Uygun hesap bulunamadı';

export const SHOWCASE_UNAVAILABLE_MESSAGE = 'Şu an için uygun hesap yoktur, '
  + 'başka bir hesap ile işlem yapabilirsiniz.';

export const isShowcaseMethod = (method) => Boolean(method?.showcase_only);

export const showcaseMessage = (method) => (
  String(method?.showcase_message || '').trim() || SHOWCASE_UNAVAILABLE_MESSAGE
);

// Yönetici kendi metnini yazdıysa sabit başlık çizilmez: "Uygun hesap
// bulunamadı" başlığı, "yöntem yakında açılacaktır" gibi bir duyuruyla
// çelişirdi. Metin yöneticinindir, başlığı da o belirler.
export const showcaseHasCustomMessage = (method) => (
  Boolean(String(method?.showcase_message || '').trim())
);

export default isShowcaseMethod;
